<template>
    <div class="tooltip">
        <slot />
        <span class="tooltiptext" v-bind:class="direction">
            <p class="text">{{ text }}</p>
        </span>
    </div>
</template>


<script>


    export default {
        name: "LToolTip",
        props: {
            text: {
                type: String,
                required: true
            },
            direction: {
                type: String,
                required: false
            },
        }
    };

</script>
<style scoped>
    /* Tooltip container */
    .tooltip {
        position: relative;
        /*display: inline-block;*/
    }

        /* Tooltip text */
        .tooltip .tooltiptext {
            visibility: hidden;
            /*width: 120px;*/
            background-color: #555;
            color: #fff;
            /*text-align: center;*/
            padding: 5px 0;
            border-radius: 6px;
            /* Position the tooltip text */
            position: absolute;
            z-index: 1;
            /*bottom: 125%;*/
            left: 50%;
            margin-left: -60px;
            /* Fade in tooltip */
            opacity: 0;
            transition: opacity 0.3s;
        }

            .tooltip .tooltiptext .text {
                margin: 6px;
            }

        .tooltip .right {
            bottom: -50%;
            left: calc(100% + 4px);
        }

        .tooltip .top {
            bottom: calc(100% + 4px);
            left: 100%;
        }

        .tooltip .top {
            bottom: calc(100% + 4px);
            left: 100%;
        }
            /* Tooltip arrow */
            .tooltip .top::after {
                content: "";
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: #555 transparent transparent transparent;
            }
        /*            .tooltip .right::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 0%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: #555 transparent transparent transparent;
            }*/

            /* Show the tooltip text when you mouse over the tooltip container */
            .tooltip:hover .tooltiptext {
            visibility: visible;
            opacity: 0.9;
        }
</style>